








var jspb=require('google-protobuf');
var goog=jspb;
var global=Function('return this')();

var mti_metadata_pb=require('../../../mti/metadata_pb.js');
var google_protobuf_timestamp_pb=require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.exportSymbol('proto.mti.store.alarm_module.State',null,global);











proto.mti.store.alarm_module.State=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.store.alarm_module.State,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.store.alarm_module.State.displayName='proto.mti.store.alarm_module.State';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.store.alarm_module.State.prototype.toObject=function(opt_includeInstance){
return proto.mti.store.alarm_module.State.toObject(opt_includeInstance,this);
};











proto.mti.store.alarm_module.State.toObject=function(includeInstance,msg){
var f,obj={
metadata:(f=msg.getMetadata())&&mti_metadata_pb.Metadata.toObject(includeInstance,f),
storeId:jspb.Message.getFieldWithDefault(msg,2,0),
serialNumber:jspb.Message.getFieldWithDefault(msg,3,""),
stateUuid:msg.getStateUuid_asB64(),
stateUpdatedAt:(f=msg.getStateUpdatedAt())&&google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance,f),
alarmModuleModel:jspb.Message.getFieldWithDefault(msg,6,""),
alarmModuleHardwareVersion:jspb.Message.getFieldWithDefault(msg,7,""),
alarmModuleFirmwareVersion:jspb.Message.getFieldWithDefault(msg,8,""),
lostCommunication:jspb.Message.getFieldWithDefault(msg,9,false),
alarmModuleIdentifying:jspb.Message.getFieldWithDefault(msg,10,false),
alarmModuleCharging:jspb.Message.getFieldWithDefault(msg,11,false),
alarmModulePowered:jspb.Message.getFieldWithDefault(msg,12,false),
deepSleep:jspb.Message.getFieldWithDefault(msg,13,false),
keyInserted:jspb.Message.getFieldWithDefault(msg,14,false),
tetherBarrelConnected:jspb.Message.getFieldWithDefault(msg,15,false),
riserOverCurrent:jspb.Message.getFieldWithDefault(msg,16,false),
busOverCurrent:jspb.Message.getFieldWithDefault(msg,17,false),
comPowerOverCurrent:jspb.Message.getFieldWithDefault(msg,18,false),
puckLostCommunication:jspb.Message.getFieldWithDefault(msg,19,false),
lifted:jspb.Message.getFieldWithDefault(msg,20,false),
puckCharging:jspb.Message.getFieldWithDefault(msg,21,false),
puckPowered:jspb.Message.getFieldWithDefault(msg,22,false),
tetherConnected:jspb.Message.getFieldWithDefault(msg,23,false),
puckSwitchOpen:jspb.Message.getFieldWithDefault(msg,24,false),
puckIdentifying:jspb.Message.getFieldWithDefault(msg,25,false),
armed:jspb.Message.getFieldWithDefault(msg,26,false),
puckSwitchAlarming:jspb.Message.getFieldWithDefault(msg,27,false),
tetherAlarming:jspb.Message.getFieldWithDefault(msg,28,false),
silentAlarming:jspb.Message.getFieldWithDefault(msg,29,false),
usbDevicePresent:jspb.Message.getFieldWithDefault(msg,30,false),
usbDeviceCharging:jspb.Message.getFieldWithDefault(msg,31,false),
usbDeviceOverCurrent:jspb.Message.getFieldWithDefault(msg,32,false),
alarming:jspb.Message.getFieldWithDefault(msg,33,false)};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.store.alarm_module.State.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.store.alarm_module.State();
return proto.mti.store.alarm_module.State.deserializeBinaryFromReader(msg,reader);
};









proto.mti.store.alarm_module.State.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=new mti_metadata_pb.Metadata();
reader.readMessage(value,mti_metadata_pb.Metadata.deserializeBinaryFromReader);
msg.setMetadata(value);
break;
case 2:
var value=reader.readUint64();
msg.setStoreId(value);
break;
case 3:
var value=reader.readString();
msg.setSerialNumber(value);
break;
case 4:
var value=reader.readBytes();
msg.setStateUuid(value);
break;
case 5:
var value=new google_protobuf_timestamp_pb.Timestamp();
reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
msg.setStateUpdatedAt(value);
break;
case 6:
var value=reader.readString();
msg.setAlarmModuleModel(value);
break;
case 7:
var value=reader.readString();
msg.setAlarmModuleHardwareVersion(value);
break;
case 8:
var value=reader.readString();
msg.setAlarmModuleFirmwareVersion(value);
break;
case 9:
var value=reader.readBool();
msg.setLostCommunication(value);
break;
case 10:
var value=reader.readBool();
msg.setAlarmModuleIdentifying(value);
break;
case 11:
var value=reader.readBool();
msg.setAlarmModuleCharging(value);
break;
case 12:
var value=reader.readBool();
msg.setAlarmModulePowered(value);
break;
case 13:
var value=reader.readBool();
msg.setDeepSleep(value);
break;
case 14:
var value=reader.readBool();
msg.setKeyInserted(value);
break;
case 15:
var value=reader.readBool();
msg.setTetherBarrelConnected(value);
break;
case 16:
var value=reader.readBool();
msg.setRiserOverCurrent(value);
break;
case 17:
var value=reader.readBool();
msg.setBusOverCurrent(value);
break;
case 18:
var value=reader.readBool();
msg.setComPowerOverCurrent(value);
break;
case 19:
var value=reader.readBool();
msg.setPuckLostCommunication(value);
break;
case 20:
var value=reader.readBool();
msg.setLifted(value);
break;
case 21:
var value=reader.readBool();
msg.setPuckCharging(value);
break;
case 22:
var value=reader.readBool();
msg.setPuckPowered(value);
break;
case 23:
var value=reader.readBool();
msg.setTetherConnected(value);
break;
case 24:
var value=reader.readBool();
msg.setPuckSwitchOpen(value);
break;
case 25:
var value=reader.readBool();
msg.setPuckIdentifying(value);
break;
case 26:
var value=reader.readBool();
msg.setArmed(value);
break;
case 27:
var value=reader.readBool();
msg.setPuckSwitchAlarming(value);
break;
case 28:
var value=reader.readBool();
msg.setTetherAlarming(value);
break;
case 29:
var value=reader.readBool();
msg.setSilentAlarming(value);
break;
case 30:
var value=reader.readBool();
msg.setUsbDevicePresent(value);
break;
case 31:
var value=reader.readBool();
msg.setUsbDeviceCharging(value);
break;
case 32:
var value=reader.readBool();
msg.setUsbDeviceOverCurrent(value);
break;
case 33:
var value=reader.readBool();
msg.setAlarming(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.store.alarm_module.State.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.store.alarm_module.State.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.store.alarm_module.State.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getMetadata();
if(f!=null){
writer.writeMessage(
1,
f,
mti_metadata_pb.Metadata.serializeBinaryToWriter);

}
f=message.getStoreId();
if(f!==0){
writer.writeUint64(
2,
f);

}
f=message.getSerialNumber();
if(f.length>0){
writer.writeString(
3,
f);

}
f=message.getStateUuid_asU8();
if(f.length>0){
writer.writeBytes(
4,
f);

}
f=message.getStateUpdatedAt();
if(f!=null){
writer.writeMessage(
5,
f,
google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);

}
f=message.getAlarmModuleModel();
if(f.length>0){
writer.writeString(
6,
f);

}
f=message.getAlarmModuleHardwareVersion();
if(f.length>0){
writer.writeString(
7,
f);

}
f=message.getAlarmModuleFirmwareVersion();
if(f.length>0){
writer.writeString(
8,
f);

}
f=message.getLostCommunication();
if(f){
writer.writeBool(
9,
f);

}
f=message.getAlarmModuleIdentifying();
if(f){
writer.writeBool(
10,
f);

}
f=message.getAlarmModuleCharging();
if(f){
writer.writeBool(
11,
f);

}
f=message.getAlarmModulePowered();
if(f){
writer.writeBool(
12,
f);

}
f=message.getDeepSleep();
if(f){
writer.writeBool(
13,
f);

}
f=message.getKeyInserted();
if(f){
writer.writeBool(
14,
f);

}
f=message.getTetherBarrelConnected();
if(f){
writer.writeBool(
15,
f);

}
f=message.getRiserOverCurrent();
if(f){
writer.writeBool(
16,
f);

}
f=message.getBusOverCurrent();
if(f){
writer.writeBool(
17,
f);

}
f=message.getComPowerOverCurrent();
if(f){
writer.writeBool(
18,
f);

}
f=message.getPuckLostCommunication();
if(f){
writer.writeBool(
19,
f);

}
f=message.getLifted();
if(f){
writer.writeBool(
20,
f);

}
f=message.getPuckCharging();
if(f){
writer.writeBool(
21,
f);

}
f=message.getPuckPowered();
if(f){
writer.writeBool(
22,
f);

}
f=message.getTetherConnected();
if(f){
writer.writeBool(
23,
f);

}
f=message.getPuckSwitchOpen();
if(f){
writer.writeBool(
24,
f);

}
f=message.getPuckIdentifying();
if(f){
writer.writeBool(
25,
f);

}
f=message.getArmed();
if(f){
writer.writeBool(
26,
f);

}
f=message.getPuckSwitchAlarming();
if(f){
writer.writeBool(
27,
f);

}
f=message.getTetherAlarming();
if(f){
writer.writeBool(
28,
f);

}
f=message.getSilentAlarming();
if(f){
writer.writeBool(
29,
f);

}
f=message.getUsbDevicePresent();
if(f){
writer.writeBool(
30,
f);

}
f=message.getUsbDeviceCharging();
if(f){
writer.writeBool(
31,
f);

}
f=message.getUsbDeviceOverCurrent();
if(f){
writer.writeBool(
32,
f);

}
f=message.getAlarming();
if(f){
writer.writeBool(
33,
f);

}
};






proto.mti.store.alarm_module.State.prototype.getMetadata=function(){
return(
jspb.Message.getWrapperField(this,mti_metadata_pb.Metadata,1));
};



proto.mti.store.alarm_module.State.prototype.setMetadata=function(value){
jspb.Message.setWrapperField(this,1,value);
};


proto.mti.store.alarm_module.State.prototype.clearMetadata=function(){
this.setMetadata(undefined);
};






proto.mti.store.alarm_module.State.prototype.hasMetadata=function(){
return jspb.Message.getField(this,1)!=null;
};






proto.mti.store.alarm_module.State.prototype.getStoreId=function(){
return jspb.Message.getFieldWithDefault(this,2,0);
};



proto.mti.store.alarm_module.State.prototype.setStoreId=function(value){
jspb.Message.setProto3IntField(this,2,value);
};






proto.mti.store.alarm_module.State.prototype.getSerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,3,"");
};



proto.mti.store.alarm_module.State.prototype.setSerialNumber=function(value){
jspb.Message.setProto3StringField(this,3,value);
};






proto.mti.store.alarm_module.State.prototype.getStateUuid=function(){
return jspb.Message.getFieldWithDefault(this,4,"");
};







proto.mti.store.alarm_module.State.prototype.getStateUuid_asB64=function(){
return jspb.Message.bytesAsB64(
this.getStateUuid());
};









proto.mti.store.alarm_module.State.prototype.getStateUuid_asU8=function(){
return jspb.Message.bytesAsU8(
this.getStateUuid());
};



proto.mti.store.alarm_module.State.prototype.setStateUuid=function(value){
jspb.Message.setProto3BytesField(this,4,value);
};






proto.mti.store.alarm_module.State.prototype.getStateUpdatedAt=function(){
return(
jspb.Message.getWrapperField(this,google_protobuf_timestamp_pb.Timestamp,5));
};



proto.mti.store.alarm_module.State.prototype.setStateUpdatedAt=function(value){
jspb.Message.setWrapperField(this,5,value);
};


proto.mti.store.alarm_module.State.prototype.clearStateUpdatedAt=function(){
this.setStateUpdatedAt(undefined);
};






proto.mti.store.alarm_module.State.prototype.hasStateUpdatedAt=function(){
return jspb.Message.getField(this,5)!=null;
};






proto.mti.store.alarm_module.State.prototype.getAlarmModuleModel=function(){
return jspb.Message.getFieldWithDefault(this,6,"");
};



proto.mti.store.alarm_module.State.prototype.setAlarmModuleModel=function(value){
jspb.Message.setProto3StringField(this,6,value);
};






proto.mti.store.alarm_module.State.prototype.getAlarmModuleHardwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,7,"");
};



proto.mti.store.alarm_module.State.prototype.setAlarmModuleHardwareVersion=function(value){
jspb.Message.setProto3StringField(this,7,value);
};






proto.mti.store.alarm_module.State.prototype.getAlarmModuleFirmwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,8,"");
};



proto.mti.store.alarm_module.State.prototype.setAlarmModuleFirmwareVersion=function(value){
jspb.Message.setProto3StringField(this,8,value);
};








proto.mti.store.alarm_module.State.prototype.getLostCommunication=function(){
return jspb.Message.getFieldWithDefault(this,9,false);
};



proto.mti.store.alarm_module.State.prototype.setLostCommunication=function(value){
jspb.Message.setProto3BooleanField(this,9,value);
};








proto.mti.store.alarm_module.State.prototype.getAlarmModuleIdentifying=function(){
return jspb.Message.getFieldWithDefault(this,10,false);
};



proto.mti.store.alarm_module.State.prototype.setAlarmModuleIdentifying=function(value){
jspb.Message.setProto3BooleanField(this,10,value);
};








proto.mti.store.alarm_module.State.prototype.getAlarmModuleCharging=function(){
return jspb.Message.getFieldWithDefault(this,11,false);
};



proto.mti.store.alarm_module.State.prototype.setAlarmModuleCharging=function(value){
jspb.Message.setProto3BooleanField(this,11,value);
};








proto.mti.store.alarm_module.State.prototype.getAlarmModulePowered=function(){
return jspb.Message.getFieldWithDefault(this,12,false);
};



proto.mti.store.alarm_module.State.prototype.setAlarmModulePowered=function(value){
jspb.Message.setProto3BooleanField(this,12,value);
};








proto.mti.store.alarm_module.State.prototype.getDeepSleep=function(){
return jspb.Message.getFieldWithDefault(this,13,false);
};



proto.mti.store.alarm_module.State.prototype.setDeepSleep=function(value){
jspb.Message.setProto3BooleanField(this,13,value);
};








proto.mti.store.alarm_module.State.prototype.getKeyInserted=function(){
return jspb.Message.getFieldWithDefault(this,14,false);
};



proto.mti.store.alarm_module.State.prototype.setKeyInserted=function(value){
jspb.Message.setProto3BooleanField(this,14,value);
};








proto.mti.store.alarm_module.State.prototype.getTetherBarrelConnected=function(){
return jspb.Message.getFieldWithDefault(this,15,false);
};



proto.mti.store.alarm_module.State.prototype.setTetherBarrelConnected=function(value){
jspb.Message.setProto3BooleanField(this,15,value);
};








proto.mti.store.alarm_module.State.prototype.getRiserOverCurrent=function(){
return jspb.Message.getFieldWithDefault(this,16,false);
};



proto.mti.store.alarm_module.State.prototype.setRiserOverCurrent=function(value){
jspb.Message.setProto3BooleanField(this,16,value);
};








proto.mti.store.alarm_module.State.prototype.getBusOverCurrent=function(){
return jspb.Message.getFieldWithDefault(this,17,false);
};



proto.mti.store.alarm_module.State.prototype.setBusOverCurrent=function(value){
jspb.Message.setProto3BooleanField(this,17,value);
};








proto.mti.store.alarm_module.State.prototype.getComPowerOverCurrent=function(){
return jspb.Message.getFieldWithDefault(this,18,false);
};



proto.mti.store.alarm_module.State.prototype.setComPowerOverCurrent=function(value){
jspb.Message.setProto3BooleanField(this,18,value);
};








proto.mti.store.alarm_module.State.prototype.getPuckLostCommunication=function(){
return jspb.Message.getFieldWithDefault(this,19,false);
};



proto.mti.store.alarm_module.State.prototype.setPuckLostCommunication=function(value){
jspb.Message.setProto3BooleanField(this,19,value);
};








proto.mti.store.alarm_module.State.prototype.getLifted=function(){
return jspb.Message.getFieldWithDefault(this,20,false);
};



proto.mti.store.alarm_module.State.prototype.setLifted=function(value){
jspb.Message.setProto3BooleanField(this,20,value);
};








proto.mti.store.alarm_module.State.prototype.getPuckCharging=function(){
return jspb.Message.getFieldWithDefault(this,21,false);
};



proto.mti.store.alarm_module.State.prototype.setPuckCharging=function(value){
jspb.Message.setProto3BooleanField(this,21,value);
};








proto.mti.store.alarm_module.State.prototype.getPuckPowered=function(){
return jspb.Message.getFieldWithDefault(this,22,false);
};



proto.mti.store.alarm_module.State.prototype.setPuckPowered=function(value){
jspb.Message.setProto3BooleanField(this,22,value);
};








proto.mti.store.alarm_module.State.prototype.getTetherConnected=function(){
return jspb.Message.getFieldWithDefault(this,23,false);
};



proto.mti.store.alarm_module.State.prototype.setTetherConnected=function(value){
jspb.Message.setProto3BooleanField(this,23,value);
};








proto.mti.store.alarm_module.State.prototype.getPuckSwitchOpen=function(){
return jspb.Message.getFieldWithDefault(this,24,false);
};



proto.mti.store.alarm_module.State.prototype.setPuckSwitchOpen=function(value){
jspb.Message.setProto3BooleanField(this,24,value);
};








proto.mti.store.alarm_module.State.prototype.getPuckIdentifying=function(){
return jspb.Message.getFieldWithDefault(this,25,false);
};



proto.mti.store.alarm_module.State.prototype.setPuckIdentifying=function(value){
jspb.Message.setProto3BooleanField(this,25,value);
};








proto.mti.store.alarm_module.State.prototype.getArmed=function(){
return jspb.Message.getFieldWithDefault(this,26,false);
};



proto.mti.store.alarm_module.State.prototype.setArmed=function(value){
jspb.Message.setProto3BooleanField(this,26,value);
};








proto.mti.store.alarm_module.State.prototype.getPuckSwitchAlarming=function(){
return jspb.Message.getFieldWithDefault(this,27,false);
};



proto.mti.store.alarm_module.State.prototype.setPuckSwitchAlarming=function(value){
jspb.Message.setProto3BooleanField(this,27,value);
};








proto.mti.store.alarm_module.State.prototype.getTetherAlarming=function(){
return jspb.Message.getFieldWithDefault(this,28,false);
};



proto.mti.store.alarm_module.State.prototype.setTetherAlarming=function(value){
jspb.Message.setProto3BooleanField(this,28,value);
};








proto.mti.store.alarm_module.State.prototype.getSilentAlarming=function(){
return jspb.Message.getFieldWithDefault(this,29,false);
};



proto.mti.store.alarm_module.State.prototype.setSilentAlarming=function(value){
jspb.Message.setProto3BooleanField(this,29,value);
};








proto.mti.store.alarm_module.State.prototype.getUsbDevicePresent=function(){
return jspb.Message.getFieldWithDefault(this,30,false);
};



proto.mti.store.alarm_module.State.prototype.setUsbDevicePresent=function(value){
jspb.Message.setProto3BooleanField(this,30,value);
};








proto.mti.store.alarm_module.State.prototype.getUsbDeviceCharging=function(){
return jspb.Message.getFieldWithDefault(this,31,false);
};



proto.mti.store.alarm_module.State.prototype.setUsbDeviceCharging=function(value){
jspb.Message.setProto3BooleanField(this,31,value);
};








proto.mti.store.alarm_module.State.prototype.getUsbDeviceOverCurrent=function(){
return jspb.Message.getFieldWithDefault(this,32,false);
};



proto.mti.store.alarm_module.State.prototype.setUsbDeviceOverCurrent=function(value){
jspb.Message.setProto3BooleanField(this,32,value);
};








proto.mti.store.alarm_module.State.prototype.getAlarming=function(){
return jspb.Message.getFieldWithDefault(this,33,false);
};



proto.mti.store.alarm_module.State.prototype.setAlarming=function(value){
jspb.Message.setProto3BooleanField(this,33,value);
};


goog.object.extend(exports,proto.mti.store.alarm_module);